export const BASE_URL_API = process.env.REACT_APP_API_URL;

export const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR || "#004897";